import { useLanguage } from '../../context/LanguageContext';
import { CATEGORIES } from '../../data/parts';
import styles from './CategoryTabs.module.css';

export default function CategoryTabs({ activeCategory, onSelectCategory }) {
    const { t } = useLanguage();

    return (
        <div className={styles.tabsContainer}>
            <div className={styles.tabs}>
                {CATEGORIES.map(cat => (
                    <button
                        key={cat.id}
                        className={`${styles.tab} ${activeCategory === cat.id ? styles.active : ''}`}
                        onClick={() => onSelectCategory(cat.id)}
                    >
                        {t(cat.nameKey)}
                    </button>
                ))}
            </div>
        </div>
    );
}
